<template>
  <div class="modal overflow-auto" select-cy="update-supporter-details">
    <div class="card inner">
      <div class="header">
        <div class="title">
          <h2>Send Update Details Email</h2>
        </div>
        <div class="close" @click="close()">
          <i class="icn icn-x sm"></i>
        </div>
      </div>
      <div class="content">
        <form id="send-link" @submit.prevent @submit="sendLink()">
          <h3 class="sub-title">Supporter's Emails</h3>
          <div class="row mt-2" v-if="hasContacts">
            <div class="field">
              <select v-model="contact">
                <option :value="c.contact" :selected="c.contact === contact" v-for="c of contacts" :key="c.id">
                  {{ c.contact }}
                </option>
              </select>
            </div>
          </div>
          <h3 class="sub-title">Or enter manual email</h3>
          <div class="row mt-2">
            <div class="field">
              <input
                v-model="contact"
                type="text"
                placeholder="Contact"
                maxlength="255"
                autocomplete="nope"
                data-cy="contact"
              />
            </div>
          </div>
          <h3 class="sub-title">Sending Email to...</h3>
          <div class="row mt-2">
            <div class="field">
              {{ contact }}
            </div>
          </div>
        </form>
      </div>

      <!-- Error Messages -->
      <Alert v-if="errorMessage" :message="errorMessage"></Alert>

      <div class="footer">
        <button class="secondary" type="button" @click="close()">Cancel</button>
        <div class="flex-grow"></div>
        <button type="button" @click="sendLink()" :disabled="!canSubmit" select-cy="submit-edit-supporter">
          <span v-if="!isValidating">Send Link</span>
          <span class="icon" v-if="isValidating">
            <i class="icn icn-refresh sm animate-reverse-spin"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// import { ALERT_TYPE, MESSAGES, CONTACT_TYPE } from '@/helpers/constants';
import { ALERT_TYPE, CONTACT_TYPE } from '@/helpers/constants';
import { MODAL_NAME } from '../../stores/supporters';
import Alert from '@/components/Alert.vue';

export default {
  name: 'SupporterSendUpdateDetails',
  components: {
    Alert,
  },

  data() {
    return {
      contact: null,
      isValidating: false,
      isProcessing: false,
      message: null,
    };
  },
  computed: {
    canSubmit() {
      return !this.isProcessing;
    },
    hasContacts() {
      return (
        this.supporter &&
        this.supporter.contacts &&
        this.supporter.contacts.filter((e) => e.type === CONTACT_TYPE.EMAIL).length > 0
      );
    },
    contacts() {
      if (this.supporter && this.supporter.contacts) {
        return this.supporter.contacts.filter((e) => e.type === CONTACT_TYPE.EMAIL);
      }
      return [];
    },
    errorMessage: {
      get() {
        return this.message;
      },
      set(value) {
        if (value === null) {
          this.message = null;
        } else {
          this.message = {
            content: value,
            type: ALERT_TYPE.ERROR,
          };
        }
      },
    },
  },
  props: {
    supporter: Object,
  },

  created() {
    if (this.hasContacts) {
      this.contact = this.contacts[0].contact;
    }
  },

  methods: {
    close() {
      this.$store.commit('supporters/close', MODAL_NAME.SEND_UPDATE_DETAILS);
    },
    sendLink() {
      if (this.isValidating) return;
      this.errorMessage = null;
      this.isValidating = true;
      const isValid = document.querySelector('#send-link').reportValidity();
      if (isValid) {
        console.log(this.contact);
        // const payload = {
        //   id: this.editItem.supporterId,
        //   contacts: [this.editItem],
        // };
        // this.$store
        //   .dispatch('supporters/edit', [payload])
        //   .then(() => {
        //     this.close();
        //   })
        //   .catch((err) => {
        //     console.error(err);
        //     if (err && err.status && err.status === 401) {
        //       this.errorMessage = MESSAGES.NO_PERMISSION;
        //     } else {
        //       this.errorMessage = MESSAGES.SERVER_ERROR;
        //     }
        //   })
        //   .finally(() => (this.isValidating = false));
        // Show notification
        setTimeout(() => {
          this.$store.dispatch('notifications/success', {
            headline: 'Email Sent',
            details: 'The update details email has been sent.',
          });
          this.close();
        }, 1000);
      } else {
        this.isValidating = false;
      }
    },
  },
};
</script>
